import React, { useEffect, useState } from "react";
import { NavBar, TopBar } from "../../components";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { UserNavTabs } from "../../data/UserNavTabs";
import { deleteDoc, doc, getDoc } from "firebase/firestore";
import { db } from "../../config/firebase";
import { COLLECTION, SESSION } from "../../data/constant";
import { routes } from "../../routing/routes";

function UserRootLayout() {
  const [fullSideBar, setFullSideBar] = useState(true);
  const [showNavTopBar, setShowNavTopBar] = useState(false);

  const { pathname } = useLocation();
  const navigate = useNavigate();

  /* -------------------------------------------
     SHOW / HIDE TOP BAR BASED ON ROUTE
  -------------------------------------------- */
  useEffect(() => {
    const showTabs = UserNavTabs.some((tab) =>
      pathname.includes(tab.tabUrl)
    );
    setShowNavTopBar(showTabs);
  }, [pathname]);

  /* -------------------------------------------
     🔐 GLOBAL SESSION VERSION VALIDATION
     Runs on every protected page load
  -------------------------------------------- */
  useEffect(() => {
    const validateSession = async () => {
      const sessionId = localStorage.getItem(SESSION.USER_SESSION_ID);
      const localSessionVersion = localStorage.getItem("SESSION_VERSION");

      // ❌ No session info → logout
      if (!sessionId || !localSessionVersion) {
        localStorage.clear();
        navigate(routes.USER_LOGIN, { replace: true });
        return;
      }

      try {
        const configRef = doc(db, COLLECTION.CONFIG, "app");
        const configSnap = await getDoc(configRef);

        if (!configSnap.exists()) {
          console.error("CONFIG/app document missing");
          return;
        }

        const globalSessionVersion = String(
          configSnap.data().sessionVersion
        );

        // ❌ Version mismatch → force logout
        if (globalSessionVersion !== localSessionVersion) {
          localStorage.clear();
          navigate(routes.USER_LOGIN, { replace: true });
        }
      } catch (error) {
        console.error("Session validation failed:", error);
        localStorage.clear();
        navigate(routes.USER_LOGIN, { replace: true });
      }
    };

    validateSession();
  }, [navigate]);

  /* -------------------------------------------
     🚪 LOGOUT HANDLER
  -------------------------------------------- */
  const logout = async () => {
    const sessionId = localStorage.getItem(SESSION.USER_SESSION_ID);

    localStorage.clear();

    if (sessionId) {
      try {
        const docRef = doc(db, COLLECTION.USER_SESSION, sessionId);
        await deleteDoc(docRef);
      } catch (err) {
        console.error("Error deleting session:", err);
      }
    }

    navigate(routes.USER_LOGIN);
  };

  /* -------------------------------------------
     UI
  -------------------------------------------- */
  return (
    <main className="root-layout" style={{ overflow: "hidden" }}>
      <div className="flex-direction-column width-100-per height-100-per" style={{ overflow: "hidden" }}>
        {showNavTopBar ? (
          <>
            <TopBar
              fullSideBar={fullSideBar}
              setFullSideBar={setFullSideBar}
              handleLogout={logout}
            />
            <div className="afterAuthorize">
              <NavBar fullSideBar={fullSideBar} tabs={UserNavTabs} />
              <Outlet />
            </div>
          </>
        ) : (
          <Outlet />
        )}
      </div>
    </main>
  );
}
export default UserRootLayout;